export enum MonitorStatus {
    null,
    clear,
    info,
    watch,
    warning,
    critical,
    emergency
}
